import React from 'react'
import { Chip, TableCell, Tooltip } from '@resiliatech/birdsong'
import styled from '@emotion/styled'
import { Info, CheckCircle } from '@mui/icons-material'
import { formatDateForTeamsTable, isDateOver30DaysOld } from './utils'

type Props = {
  isActive: boolean
  createdAt: Date
  lastInviteSentAt?: Date
}

export const StatusCell = ({
  isActive,
  lastInviteSentAt,
  createdAt,
}: Props) => {
  if (isActive) {
    return (
      <TableCell>
        <Chip
          label='Joined'
          variant='filled'
          size='small'
          color='success'
          icon={<CheckCircle style={{ color: 'rgba(255, 255, 255, 0.7)' }} />}
        />
      </TableCell>
    )
  }

  return (
    <TableCell>
      {isDateOver30DaysOld(lastInviteSentAt || createdAt) ? (
        <Chip
          label='Invite Expired'
          variant='filled'
          size='small'
          color='error'
        />
      ) : (
        <Tooltip
          style={{ display: 'inherit' }}
          title={`Invited on ${formatDateForTeamsTable(
            lastInviteSentAt || createdAt
          )}`}
        >
          <AnonymousChip
            label='Invited'
            variant='filled'
            size='small'
            icon={<Info style={{ color: 'rgba(255, 255, 255, 0.7)' }} />}
          />
        </Tooltip>
      )}
    </TableCell>
  )
}

const AnonymousChip = styled(Chip)`
  background-color: #333333;
  color: #ffffff;
`
